<ion-row class="phi-align-items-center">
  <ion-col size>
    <h5 class="ml-10 fw-b">{{ counterName }}</h5>
  </ion-col>

  <!-- --------------- Download ------------ -->
  <ion-col size="auto">
    <button matButton mat-dialog-close class="dialog_btns close_btn"><ion-icon name="close-outline"></ion-icon></button>
  </ion-col>
</ion-row>

<mat-dialog-content class="p-0">
  <ion-grid class="confirmation-body">
    <ion-row class="ion-align-items-center ">
      <ion-col size>
        <!-- <div class="mb-10"> -->
        <!-- Left labels -->
        <label class="mr-10" *ngIf="counterName === 'DWM Approved'">Not Approved</label>
        <label class="mr-10" *ngIf="counterName === 'DWM Submitted'">Not Submitted</label>
        <label class="mr-10" *ngIf="counterName === 'Total R&D Hours Logged'">Department</label>

        <label class="mr-10" *ngIf="counterName === 'Avg Compliance Score' &&  (!isManagerOrHOD || loggedInUserRole === 'HR Admin' || userIsAdminTypes?.userIsAdmin)">Score By Grade</label>

        <!-- Toggle -->
        <mat-slide-toggle class="mr-10" *ngIf=" counterName === 'DWM Submitted' || counterName === 'DWM Approved' || counterName === 'Total R&D Hours Logged' || (counterName === 'Avg Compliance Score' &&  (!isManagerOrHOD || loggedInUserRole === 'HR Admin' || userIsAdminTypes?.userIsAdmin)) " [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>

        <!-- Right labels -->
        <label class="mr-10" *ngIf="counterName === 'DWM Approved'">Approved</label>
        <label class="mr-10" *ngIf="counterName === 'DWM Submitted'">Submitted</label>
        <label class="mr-10" *ngIf="counterName === 'Total R&D Hours Logged'">Product Number</label>

        <label class="mr-10" *ngIf="counterName === 'Avg Compliance Score' &&  (!isManagerOrHOD || loggedInUserRole === 'HR Admin' || userIsAdminTypes?.userIsAdmin)">Score By Department</label>
        <!-- </div> -->
      </ion-col>
      <ion-col size="auto">
        <img src="assets/svg/excel.svg" class="file-icon" (click)="downloadPDFAndExcel('excel')" />
      </ion-col>
    </ion-row>

    <!-- ----------------------- DWM Submitted(HR) --------------------------- -->

    <div class="p-10" *ngIf="counterName === 'DWM Submitted'">
      <div class="table-scroll">
        <table>
          <tr>
           <th *ngIf="loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin' || loggedInUserRole=='Admin'">Employee ID</th>
            <th>Employee Name</th>
            <th *ngIf="loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin'">Plant Location</th>
            <th>Department</th>
            <th>Grade</th>
            <th *ngIf="isToggleOn && (loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin' || loggedInUserRole=='Admin')">Total Tasks Submitted for Approval </th>
            <th *ngIf="!isToggleOn && (loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin' || loggedInUserRole=='Admin')">Total Draft Tasks </th>
            <!-- <th>Submission Date</th> -->
          </tr>
          <tr *ngFor="let item of submittedTaskEmployee">
            <td *ngIf="loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin' || loggedInUserRole=='Admin'">{{item?.employeeId}}</td>
            <td>{{item?.userName}}</td>
            <td *ngIf="loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin'">{{item?.plantLocation}}</td>
            <td>{{item?.department}}</td>
            <td>{{item?.grade}}</td>
            <td *ngIf="isToggleOn && (loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin' || loggedInUserRole=='Admin')">{{item?.submittedCount}}</td>
            <td *ngIf="!isToggleOn && (loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin' || loggedInUserRole=='Admin')">{{item?.draftCount}}</td>
            <!-- <td>{{item?.submissionDate | date: 'dd-MM-yyyy'}}</td> -->
          </tr>
          <tr *ngIf="!submittedTaskEmployee.length">
            <td colspan="4" class="text-center">No data available</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>

    <!-- ------------------------------ DWM Approved(HR) ------------------------ -->
    <div class="p-10" *ngIf="counterName === 'DWM Approved'">
      <!-- <ion-col> -->
      <div class="table-scroll">
        <table>
          <tr>
             <th *ngIf="loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin' || loggedInUserRole=='Admin'">Employee ID</th>
            <th>Employee Name</th>
            <th>Manager Name</th>
            <th *ngIf="loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin'">Plant Location</th>
            <th>Department</th>
            <th>Grade</th>
            <th *ngIf="isToggleOn">Approved Tasks</th>
            <th *ngIf="!isToggleOn">Not Approved Tasks</th>
            <th>No of Rejected Tasks</th>
          </tr>
          <tr *ngFor="let item of filteredApprovedTaskEmployee">
           <td *ngIf="loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin' || loggedInUserRole=='Admin'">{{item?.employeeId}}</td>
            <td>{{item?.userName}}</td>
            <td>{{item?.managerName}}</td>
            <td *ngIf="loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin'">{{item?.plantLocation}}</td>
            <td>{{item?.department}}</td>
            <td>{{item?.grade}}</td>
            <td *ngIf="isToggleOn">{{item?.noOfApprovedTasks}}</td>
            <td *ngIf="!isToggleOn">{{item?.noOfPendingTasks}}</td>
            <td>{{item?.noOfRejectedTasks}}</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>

    <!-- ------------------------------- Total R&D Logged(HR) -------------------- -->
    <div class="p-10" *ngIf="counterName == 'Total R&D Hours Logged' ">
      <!-- <ion-col> -->
      <div class="table-scroll">
        <table>
          <tr>
            <th *ngIf="isToggleOn">Product Number</th>
            <th *ngIf="isToggleOn && (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin')">Product Name</th>
             <th *ngIf="isToggleOn && (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin')">Plant Location</th>
            <th *ngIf="isToggleOn && (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin')">Business Unit</th>
            <th *ngIf="isToggleOn && (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin')">Customer Name</th> 
            <th *ngIf="!isToggleOn">Department</th>
            <th>Total Hours Logged</th>
            <th>No of Employees</th>
            <th>Average Hours per Employee</th>
          </tr>
          <tr *ngFor="let item of durationRnDEmployee">
            <td *ngIf="isToggleOn">{{item?.productNo}}</td>
             <td *ngIf="isToggleOn && (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin')">{{item?.productName}}</td>
            <td *ngIf="isToggleOn && (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin')">{{item?.plantLocation}}</td>
            <td *ngIf="isToggleOn && (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin')">{{item?.businessUnit}}</td>
            <td *ngIf="isToggleOn && (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin')">{{item?.customerName}}</td> 
            <td *ngIf="!isToggleOn">{{item?.department}}</td>
            <td>{{item?.totalHours}}</td>
            <td>{{item?.noOfEmployees}}</td>
            <td>{{item?.averageHoursOfEmployees}}</td>
          </tr>
          <tr *ngIf="!durationRnDEmployee.length">
            <td colspan="4" class="text-center">No data available</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>

    <!-- ------------------------------- Total R&D Logged(Employee) -------------------- -->
    <div class="p-10" *ngIf="counterName === 'Total Duration Worked' && loggedInUserRole === 'Employee'">
      <!-- <ion-col> -->
      <div class="table-scroll">
        <table>
          <tr>
            <th>Product Number</th>
            <th>Plant</th>
            <th>Total Duration</th>
            <th>Number of Tasks</th>
          </tr>

          <tr *ngFor="let item of employeeMangerRNDDurationData">
            <td>{{ item?.productNo }}</td>
            <td>{{ item?.plant }}</td>
            <td>{{ item?.totalHours }}</td>
            <td>{{ item?.noOfTask }}</td>
          </tr>

          <tr *ngIf="!employeeMangerRNDDurationData.length">
            <td colspan="4" class="text-center">No data available</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>

    <!-- ------------------------------- Total R&D Logged(Manager) -------------------- -->
    <div class="p-10" *ngIf="counterName === 'Total Duration Worked(R&D)' && ( loggedInUserRole === 'Manager' ||  loggedInUserRole === 'HOD')">
      <!-- <ion-col> -->
      <div class="table-scroll">
        <table>
          <tr>
            <th>Product Number</th>
            <th>Total Hours</th>
            <th>Number of Employees</th>
            <th>Average Hours per Employee</th>
          </tr>

          <tr *ngFor="let item of employeeMangerRNDDurationData">
            <td>{{ item?.productNo }}</td>
            <td>{{ item?.totalHours }}</td>
            <td>{{ item?.noOfUsers }}</td>
            <td>{{ item?.averageWorkedHours }}</td>
          </tr>

          <tr *ngIf="!employeeMangerRNDDurationData.length">
            <td colspan="4" class="text-center">No data available</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>

    <!-- --------------------------------- Average complaince (HR) ----------- -->

    <div class="p-10" *ngIf="counterName == 'Avg Compliance Score' &&  (!isManagerOrHOD || loggedInUserRole === 'HR Admin' || userIsAdminTypes?.userIsAdmin)">
      <!-- <ion-col> -->
      <div class="table-scroll">
        <table>
          <tr>
            <th *ngIf="isToggleOn">Department</th>
            <th *ngIf="!isToggleOn">Grade</th>
            <th *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin'">Plant Location</th>
            <th>Average Compliance %</th>
            <th>No of Employees</th>
          </tr>

          <tr *ngFor="let item of complianceTableData">
            <td *ngIf="isToggleOn">{{ item?.department || '-' }}</td>
            <td *ngIf="!isToggleOn">{{ item?.grade || '-' }}</td>
            <td *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin'">{{item?.plantLocation }}</td>
            <td>{{ item?.averageComplianceScore || 0 }}</td>
            <td>{{ item?.noOfEmployees || 0 }}</td>
          </tr>

          <tr *ngIf="!complianceTableData.length">
            <td colspan="4" class="text-center">No data available</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>

    <!-- ----------------------- Average complaince  (manager) ------------------ -->
    <!-- <ion-row *ngIf="counterName == 'Avg Compliance Score' && isManagerOrHOD"> -->
    <div class="p-10" *ngIf="counterName == 'Avg Compliance Score' && isManagerOrHOD && (loggedInUserRole !== 'HR Admin' && !userIsAdminTypes?.userIsAdmin)">
      <!-- <ion-col> -->
      <div class="table-scroll">
        <table>
          <tr>
            <th>Employee Name</th>
            <th>Department</th>
            <th>Grade</th>
            <th>Compliance Score %</th>
          </tr>

          <tr *ngFor="let item of managerComplainceData">
            <td>{{item?.userName}}</td>
            <td>{{item?.department}}</td>
            <td>{{item?.grade}}</td>
            <td>{{ item?.complianceScore | number:'1.0-2' }}%</td>
          </tr>

          <tr *ngIf="!managerComplainceData.length">
            <td colspan="4" class="text-center">No data available</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>

    <!-- ----------------------------- Count of task (Manager) ---------------------------->
    <div class="p-10" *ngIf="counterName == 'Count of Task Sent' ">
      <!-- <ion-col> -->
      <div class="table-scroll">
        <table>
          <tr>
            <th>Employee Name</th>
            <th>Department</th>
            <th>Grade</th>
            <th>Task Sent</th>
          </tr>
          <tr *ngFor="let item of submitApprovedTask ">
            <td>{{item?.userName}}</td>
            <td>{{item?.department}}</td>
            <td>{{item?.grade}}</td>
            <td>{{item?.nofTasksSent}}</td>
          </tr>

          <tr *ngIf="!submitApprovedTask.length">
            <td colspan="4" class="text-center">No data available</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>

    <!-- --------------------------------- Count of Task Appproved  (Manager -------------------) -->
    <div class="p-10" *ngIf="counterName == 'Count of Task Approved'">
      <!-- <ion-col> -->
      <div class="table-scroll">
        <table>
          <tr>
            <th>Employee Name</th>
            <th>Department</th>
            <th>Grade</th>
            <th>Task Approved</th>
            <th>Approval Rate%</th>
          </tr>
          <tr *ngFor="let item of submitApprovedTask">
            <td>{{item?.userName}}</td>
            <td>{{item?.department}}</td>
            <td>{{item?.grade}}</td>
            <td>{{item?.noOfApprovedTask}}</td>
            <td>{{item?.approvalPercentage}}</td>
          </tr>
          <tr *ngIf="!submitApprovedTask.length">
            <td colspan="4" class="text-center">No data available</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>

    <!-- ----------------------------- Task COmpletion breakdown  (Manager)----------------------- -->

    <div class="p-10" *ngIf="counterName === 'Done on Time' || counterName === 'Done with Delay' || counterName === 'Incomplete After Due Date' || counterName === 'Not Completed'">
      <!-- <ion-col> -->
      <div class="table-scroll">
        <table>
          <tr>
            <th>Employee Name</th>
            <th>{{ counterName }}</th>
          </tr>

          <tr *ngFor="let item of statusBreakdownData">
            <td>{{ item?.userName }}</td>
            <td>{{ getStatusValue(item) }}</td>
          </tr>

          <tr *ngIf="!statusBreakdownData.length">
            <td colspan="2" class="text-center">No data available</td>
          </tr>
        </table>
      </div>
      <!-- </ion-col> -->
    </div>
  </ion-grid>
</mat-dialog-content>
